import { TCustomEventName } from '@/constants/custom-event-names.type';

export const createCustomEvent = <T>(name: TCustomEventName, detail?: T) =>
  detail ? new CustomEvent(name, { detail }) : new Event(name);

export const dispatchCustomEvent = <T>(name: TCustomEventName, detail?: T) => {
  const event = createCustomEvent(name, detail);

  window.dispatchEvent(event);
};
